import { createFileRoute } from '@tanstack/react-router';

import { ExamCreateTemplate } from '@/features/exam-management';

export const Route = createFileRoute('/_authenticated/exams/create/' as never)({
  component: ExamCreatePage,
});

function ExamCreatePage() {
  return <ExamCreateTemplate />;
}
